module.exports = __webpack_public_path__ + "static/media/chevron-square-down.1f7b520f.svg";